module.exports = __webpack_public_path__ + "static/media/voucher-preview.35073ce4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/voucher-preview.png
// module id = 925
// module chunks = 0